import React, { FC } from "react"
import styles from "./index.module.less"
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { Button, Toast } from "antd-mobile";

interface WelfareTitleProps {
  title: string;
  copycontent?: string;
}
const BlockchainTitle: FC<WelfareTitleProps> = ({ title, copycontent }) => {
  return <div className={styles.title}>
    <div className={styles['title-text']}>{title}</div>
    {copycontent && <CopyToClipboard text={copycontent ?? ''} onCopy={() => Toast.show({
      content: title === '存证保全ID：' ? '复制成功' : <div style={{ textAlign: "center" }}>
        <div>复制成功</div>
        <div>请前往浏览器打开链接</div>
      </div>
    })}>
      <Button size='small' shape='rounded' className={styles['title-copy']}>复制</Button>
    </CopyToClipboard>}
  </div>
}
export default BlockchainTitle
